import { INPUT_TYPE } from '~/components/Shc/Ui/Input/input'

export function handlePasswordSuffixIcon({
    passwordInputType,
    passwordSuffixIcon,
}: {
    passwordInputType: Ref<(typeof INPUT_TYPE)[keyof typeof INPUT_TYPE]>
    passwordSuffixIcon: Ref<string>
}) {
    passwordSuffixIcon.value = passwordSuffixIcon.value === 'visibility_off' ? 'visibility' : 'visibility_off'
    passwordInputType.value = passwordInputType.value === INPUT_TYPE.password ? INPUT_TYPE.text : INPUT_TYPE.password
}
